import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24eb0a0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "checkAddressModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "checkAddressModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title text-white" }, "Address information", -1))
const _hoisted_6 = {
  ref: "closeBtn",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close btn-close-white"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = {
  class: "",
  id: "address"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-dark" }, "Business Information", -1))
const _hoisted_13 = { class: "col-md-6 mt-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-dark" }, "Business Name (optional)", -1))
const _hoisted_15 = { class: "col-md-6 mt-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-dark" }, "Tax Identifier (optional)", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-dark" }, "Address", -1))
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6 mt-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-dark" }, "Country Code", -1))
const _hoisted_22 = { class: "col-md-6 mt-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-dark" }, "Region (optional)", -1))
const _hoisted_24 = { class: "col-md-6 mt-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-dark" }, "Street", -1))
const _hoisted_26 = { class: "col-md-6 mt-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-dark" }, "Postal Code", -1))
const _hoisted_28 = { class: "col-md-6 mt-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-dark" }, "City", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "clearfix" }, null, -1))
const _hoisted_31 = { class: "modal-footer" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 ms-2" }, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "text-danger mt-4 ps-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _hoisted_8, 512)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "ChatApp Inc.",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.businessInformation.business.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.businessInformation.business.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "555952383",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.businessInformation.business.taxIdentifier) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.businessInformation.business.taxIdentifier]
                ])
              ])
            ]),
            _hoisted_17,
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "DE",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.businessInformation.address.countryCode) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.businessInformation.address.countryCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Hamburg",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.businessInformation.address.region) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.businessInformation.address.region]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Große Freiheit 7",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.businessInformation.address.firstLine) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.businessInformation.address.firstLine]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "20357",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.businessInformation.address.postalCode) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.businessInformation.address.postalCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Hamburg",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.businessInformation.address.city) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.businessInformation.address.city]
                ])
              ])
            ]),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary fw-bolder float-end mt-8",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            disabled: _ctx.noAddress
          }, [
            _createTextVNode(_toDisplayString(_ctx.storing ? "Updating.." : "Continue") + " ", 1),
            _hoisted_33
          ], 8, _hoisted_32),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_34, " An error has occurred please check your input. "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}